// GENERATED FILE — DO NOT EDIT MANUALLY
// Generated from: public/config/domains/auth.registry.yml
// Run `npm run codegen` to regenerate

export enum AuthEvents {
  AUTH_LOGIN_SUCCESS = "auth_login_success",
  AUTH_LOGIN_FAILED = "auth_login_failed",
  AUTH_LOGOUT_SUCCESS = "auth_logout_success",
  AUTH_STATE_CHANGED = "auth_state_changed",
  AUTH_LOGIN_REQUESTED = "auth_login_requested",
  AUTH_LOGOUT_REQUESTED = "auth_logout_requested",
}

export enum AuthEndpoints {
  LOGIN = "/api/v1/auth/login",
  LEGACY_LOGIN = "/api/v1/login",
  SIGNUP = "/api/v1/signup",
  CURRENT_USER = "/api/v1/auth/me",
  LOGOUT = "/api/v1/auth/logout",
  GOOGLE_LOGIN_LINK = "/api/v1/google-login-link",
  GITHUB_LOGIN_LINK = "/api/v1/github-login-link",
}
